import { BrandName } from './types';

export default class Brands {
    static brandInfo: Map<string, any> = new Map([
        [BrandName.bzi, { insurerId: 2 }],
        [BrandName.asi, { insurerId: 3 }],
        [BrandName.cus, { insurerId: 4 }],
    ]);

    static brandInsurerID = (brandName: BrandName) => {
        if (Brands.brandInfo.has(brandName)) {
            return Brands.brandInfo.get(brandName).insurerId;
        }
    };
}

export const setBrandIconAndStoredValue = (brandName: BrandName) => {
    let iconPath, pageTitle;
    switch (brandName) {
        case BrandName.bzi:
            iconPath = '/favicon-bzi.png';
            pageTitle = 'Blue Zebra';
            break;
        case BrandName.asi:
            iconPath = '/favicon-asi.png';
            pageTitle = 'All State';
            break;
        case BrandName.cus:
            iconPath = '/favicon-cus.png';
            pageTitle = 'Chase';
            break;
    }

    if (iconPath) {
        const existingIconLink = document.querySelector('link[rel="icon"]');
        if (existingIconLink) existingIconLink.setAttribute('href', iconPath);
    }

    if(pageTitle) document.title = pageTitle;
    
    localStorage.setItem('auth.brand', brandName);
};